import "~/bootstrap";
import "babel-polyfill";
import "~/plugins";
import "./services/mixins";
import "./services/vuetify-overrides";
import store from "~/store";
import App from "~/App.vue";
import router from "./router";
import Vue from "vue";
import vuetify from "./services/vuetify";
import models from "./models/index";

window.vm = new Vue({
    el: "#app",
    models,
    store,
    router,
    vuetify,
    render: h => h(App)
});
